import { render, staticRenderFns } from "./missed_call.vue?vue&type=template&id=3cdd7c13&"
import script from "./missed_call.vue?vue&type=script&lang=js&"
export * from "./missed_call.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports